import script from "./ItemsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ItemsDetails.vue?vue&type=style&index=0&id=07261291&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07261291"]])

export default __exports__